/**
 * Owner: Masa Bayu
 * File: ProfileShell.tsx
 * Date:Time: 2026-10-17 16:06
 * Description: Profile page frame — sidebar + themed content card for profile routes.
 */

import type { ReactNode } from 'react';
import { ProfileSidebar } from './author-profile-sidebar';
import './author-profile.css';
import './author-profile-sections.css';
import './author-profile-embed.css';

export interface ProfileShellProps {
  readonly activeId: string;
  readonly onNavigate: (path: string) => void;
  readonly children: ReactNode;
}

export function ProfileShell({ activeId, onNavigate, children }: ProfileShellProps) {
  return (
    <div className="axp axp--page">
      <ProfileSidebar activeId={activeId} onNavigate={onNavigate} />
      <div className="axp__main axp__main--page">
        <div className="axp__page-card">{children}</div>
      </div>
    </div>
  );
}
